import { customerInvoice } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
  getCustomerInvoiceList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(customerInvoice.customerInvoiceBase, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getInvoiceListStatistics(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${customerInvoice.customerInvoiceBase}invoice_statistics/`, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  addCustomerInvoice(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(customerInvoice.customerInvoiceBase, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  addCustomerInvoiceBulkCreate(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${customerInvoice.customerInvoiceBase}bulk_create_invoice/`,
          data
        )
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  addCustomerSplitInvoiceBulkCreate(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${customerInvoice.customerInvoiceBase}bulk_create_split_invoice/`,
          data
        )
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getCustomerInvoiceObject(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${customerInvoice.customerInvoiceBase}${id}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  generateInvoiceFromDA(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${customerInvoice.customerInvoiceBase}preview_invoices/`, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  generateSplitInvoiceFromDA(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${customerInvoice.customerInvoiceBase}preview_split_invoices/`,
          data
        )
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  generateBulkInvoiceForAllDA(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${customerInvoice.customerInvoiceBase}bulk_invoice/`, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getCreditNoteListStatistics(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${customerInvoice.creditNoteBase}credit_note_statistics/`, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
   getDebitNoteListStatistics(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${customerInvoice.debitNoteBase}debit_note_statistics/`, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  DebitNoteAdd(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${customerInvoice.debitNoteBase}create_full_debit_note/`, 
          data,
        )
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  PartialDebitNoteAdd(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${customerInvoice.debitNoteBase}create_partial_debit_note/`, 
          data,
        )
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  downloadDAExcel(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${customerInvoice.customerInvoiceBase}${id}/download_da_excel_sheet`,
          {
            responseType: "blob",
          }
        )
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  addDAToInvoice(payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${customerInvoice.customerInvoiceBase}${payload.id}/add_invoice_da/`,
          payload.data
        )
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  similarCustomerInvoiceDA(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${customerInvoice.customerInvoiceBase}${id}/similar_customer_invoice_da`
        )
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  sendPDFEmail(payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${customerInvoice.customerInvoiceBase}${payload.id}/send_pdf_email`,
          {
            params: payload.emailId,
          }
        )
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getCustomerInvoiceBlopObject(id, params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${customerInvoice.customerInvoiceBase}${id}/download`, {
          params: params,
          responseType: "blob",
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getCreditNoteBlobObject(id, params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${customerInvoice.creditNoteBase}${id}/credit_note_download/`, {
          params: params,
          responseType: "blob",
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getCustomerInvoiceDetails(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${customerInvoice.customerInvoiceBase}${id}/view/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  createCustomerInvoice(payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${customerInvoice.customerInvoiceBase}`, payload)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getCreditNoteList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(customerInvoice.creditNoteBase, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
   getDebitNoteList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(customerInvoice.debitNoteBase, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },

  getCreditNoteLogs(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${customerInvoice.creditNoteBase}${id}/credit_note_logs/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  
  getDebitNoteLogs(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${customerInvoice.debitNoteBase}${id}/debit_note_logs/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  partiallyUpdateCreditNote(id, payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${customerInvoice.creditNoteBase}${id}/`, payload)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  createCustomerInvoiceCreditNote(payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${customerInvoice.creditNoteBase}`, payload)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  createMiscCustomerInvoiceCreditNote(payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${customerInvoice.misccreditNoteBase}`, payload)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  createFullCreditNote(payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${customerInvoice.creditNoteBase}full_invoice_credit_note/`,
          payload
        )
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getCreditNoteObject(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${customerInvoice.creditNoteBase}${id}`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getCreditNoteInvoiceAdditionalChargeList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${customerInvoice.creditNoteChargeBase}`, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  updateSingleCreditCharge(id, payload) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${customerInvoice.creditNoteChargeBase}${id}/`, payload)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  removeChargesFromCreditNote(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${customerInvoice.creditNoteChargeBase}${id}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  partiallyUpdateInvoiceCredit(id, payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${customerInvoice.creditNoteBase}${id}/`, payload)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  statusUpdateCreditNote(id, payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${customerInvoice.creditNoteBase}${id}/accept/`, payload)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
    partiallyUpdateMiscInvoiceCredit(id, payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${customerInvoice.misccreditNoteBase}${id}/send_to_sap_misc/`, payload)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  updateCustomerInvoice(payload) {
    return new Promise((resolve, reject) => {
      axios
        .put(
          `${customerInvoice.customerInvoiceBase}${payload.id}/`,
          payload.data
        )
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  partiallyUpdateCustomerInvoice(id, payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${customerInvoice.customerInvoiceBase}${id}/update_status/`, payload)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  updateInvoiceData(id, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${customerInvoice.customerInvoiceBase}${id}/update_invoice_data/`, payload)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getCustomerInvoiceOptions() {
    return new Promise((resolve, reject) => {
      axios
        .options(customerInvoice.customerInvoiceBase)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getCustomerInvoiceLogs(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${customerInvoice.customerInvoiceBase}${id}/invoice_logs/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getCustomerInvoiceGroup(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${customerInvoice.customerInvoiceBase}${id}/group_by_invoice/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getCustomerInvoiceAdditionalChargeList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${customerInvoice.singleChargeBase}`, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getChargeObject(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${customerInvoice.singleChargeBase}${id}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getDAChargeSelect(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${customerInvoice.singleChargeBase}select/`, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  addSingleCharge(payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(customerInvoice.singleChargeBase, payload)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  updateSingleCharge(id, payload) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${customerInvoice.singleChargeBase}${id}/`, payload)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  deleteSingleCharge(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${customerInvoice.singleChargeBase}${id}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getBulkIvoiceLogsList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${customerInvoice.creditNoteChargeBase}`, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getInvoiceCostRevenueCharges(id, params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${customerInvoice.customerInvoiceBase}${id}/invoice_cost_revenue_charges/`, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getCreditNoteAttachmentList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${customerInvoice.creditNoteAttachment}`, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  creditNoteAttachment(payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(customerInvoice.creditNoteAttachment, payload)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getDownloadDocumentsBlobObject(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${customerInvoice.creditNoteAttachment}${id}/download/`, {
          responseType: "blob",
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  deleteCreditNoteDocument(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${customerInvoice.creditNoteAttachment}${id}`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
   partiallyUpdateStatusDebitNote(id, payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${customerInvoice.debitNoteBase}${id}/update_status_from_pending/`, payload)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
});
